import { render, staticRenderFns } from "./CongNo.vue?vue&type=template&id=4252314e&scoped=true&"
import script from "./CongNo.vue?vue&type=script&lang=js&"
export * from "./CongNo.vue?vue&type=script&lang=js&"
import style0 from "./CongNo.vue?vue&type=style&index=0&id=4252314e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252314e",
  null
  
)

export default component.exports